import React, { Component } from 'react'
import './Video.css'
import classNames from 'classnames'

class Video extends Component {
  componentWillReceiveProps (nextProps) {
    let mySlide = this.props.slideIndex
    let activeSlide = nextProps.currentSlide

    if (mySlide === activeSlide) {
      this.startVideo()
    } else {
      this.stopVideo()
    }
  }

  componentDidMount () {
    let mySlide = this.props.slideIndex
    let activeSlide = this.props.currentSlide

    if (mySlide === activeSlide) {
      this.startVideo()
    } else {
      this.stopVideo()
    }
  }

  stopVideo () {
    try {
      this.videoElement.pause()
      this.videoElement.currentTime = 0
    } catch (error) {

    }
  }

  startVideo () {
    try {
      this.videoElement.play()
    } catch (error) {

    }
  }

  render () {
    const { src, bgColor = '#000' } = this.props

    let classes = classNames({
      'Video': true
    })

    return (
      <div className={classes} style={{backgroundColor: bgColor}}>
        {src !== '' &&
          <video
            className='Video-Player'
            src={src}
            loop
            preload='auto'
            ref={(videoElement) => { this.videoElement = videoElement }} />
        }
      </div>
    )
  }
}

export default Video



// WEBPACK FOOTER //
// ./src/Components/Video/Video.js